import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/view/components/ui/use-toast";
import { salvcarService } from "../services/salvcarService";
import {
  MakeProposalRequest,
  MakeProposalResponse,
} from "../services/salvcarService/makeProposal";

export const useSalvcarMutations = () => {
  const queryClient = useQueryClient();

  const makeProposalMutation = useMutation<
    MakeProposalResponse,
    Error,
    MakeProposalRequest
  >({
    mutationFn: salvcarService.makeProposal,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["transactions", "allTransactions"],
      });
    },
    onError: (error) => {
      toast({
        title: "Erro ao enviar proposta",
        description:
          typeof error === "string"
            ? error
            : "Ocorreu um problema ao processar a proposta. Tente novamente.",
        variant: "destructive",
      });
    },
  });

  return {
    makeProposalMutation,
  };
};
